import {
  all, call, put, select, takeEvery,
} from 'redux-saga/effects';
import { studiosApi } from '@api';
import {
  LOAD_STUDIOS_LIST,
  LOAD_STUDIOS_COUNTS,
  CREATE_STUDIO,
  UPDATE_STUDIO,
  DELETE_STUDIO,
  LOAD_STUDIO,
  loadStudiosList,
  renderStudiosList,
  renderStudiosCounts,
  renderStudio,
} from './actions';
import { selectCurrentCompany } from '@store/app/selectors';
import addHiddenStateForItems from '@shared/utils/addHiddenStateForItems';
import { actions as appActions } from '@store/app/index';

export function* fetchStudiosList() {
  try {
    const data = yield call(studiosApi.getStudios);
    const company = yield select(selectCurrentCompany);
    yield put(renderStudiosList(addHiddenStateForItems(data, company)));
  } catch (error) {
    console.error(error);
  }
}

export function* fetchStudio({ id }) {
  try {
    const data = yield call(studiosApi.getStudio, id);
    yield put(renderStudio(data));
  } catch (error) {
    console.error(error);
  }
}

export function* fetchStudiosCounts() {
  try {
    const data = yield call(studiosApi.getStudiosCounts);
    yield put(renderStudiosCounts(data));
  } catch (error) {
    console.error(error);
  }
}

export function* fetchPostStudio({ studio, setError }) {
  try {
    const data = yield call(studiosApi.createStudio, studio);
    yield put(renderStudio({
      ...data,
      ...studio,
    }));
    yield put(loadStudiosList());
  } catch (error) {
    if (error.response?.data) {
      const apiError = error.response?.data;
      const titles = apiError.message.map((message) => {
        if (message.reason === 'unique') {
          setError(message.property, {});
          return `Property '${message.property}' should be unique`;
        }
      });
      yield put(appActions.addMessage({ message: titles.join('\n'), type: 'error' }));
      return;
    }
    console.error(error);
    yield put(appActions.addMessage({ message: 'Unexpected error during creating the Product', type: 'error' }));
  }
}

export function* fetchPutStudio({ studio, setError }) {
  try {
    const data = yield call(studiosApi.updateStudio, studio);
    yield put(renderStudio({
      ...data,
      ...studio,
    }));
    yield put(loadStudiosList());
  } catch (error) {
    if (error.response?.data) {
      const apiError = error.response?.data;
      const titles = apiError.message.map((message) => {
        if (message.reason === 'unique') {
          setError(message.property, {});
          return `Property '${message.property}' should be unique`;
        }
      });
      yield put(appActions.addMessage({ message: titles.join('\n'), type: 'error' }));
      return;
    }
    console.error(error);
    yield put(appActions.addMessage({ message: 'Unexpected error during creating the Product', type: 'error' }));
  }
}

export function* fetchDeleteStudio({ id }) {
  try {
    yield call(studiosApi.deleteStudio, id);
    yield put(loadStudiosList());
  } catch (error) {
    console.error(error);
  }
}

export default function* studiosSaga() {
  yield all([
    takeEvery(LOAD_STUDIOS_LIST, fetchStudiosList),
    takeEvery(LOAD_STUDIOS_COUNTS, fetchStudiosCounts),
    takeEvery(CREATE_STUDIO, fetchPostStudio),
    takeEvery(UPDATE_STUDIO, fetchPutStudio),
    takeEvery(DELETE_STUDIO, fetchDeleteStudio),
    takeEvery(LOAD_STUDIO, fetchStudio),
  ]);
}
